/* tslint:disable */
/* eslint-disable */
/**
 * Warpgate HTTP proxy
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.22.0-beta.4-11-ge6c01455-modified
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the LoginRequest interface.
 */
export function instanceOfLoginRequest(value) {
    if (!('username' in value) || value['username'] === undefined)
        return false;
    if (!('password' in value) || value['password'] === undefined)
        return false;
    return true;
}
export function LoginRequestFromJSON(json) {
    return LoginRequestFromJSONTyped(json, false);
}
export function LoginRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'username': json['username'],
        'password': json['password'],
    };
}
export function LoginRequestToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'username': value['username'],
        'password': value['password'],
    };
}
